import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { component_tool, framework_tool, utils_tool } from '@/tool'
import moment from "moment";
import { identity } from "lodash";

let { WizContainer } = framework_tool
let { WizCard, WizSpin } = component_tool
let { Session } = utils_tool

const formatterDate = (val) => {
    return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const _getValue = (type, key) => {
    const values = {
        state: {
            '0': '无效',
            '1': '有效',
        },
        baseType: {
            '0': '否',
            '1': '是',
        }
    }
    return values[type][key] || ''
}

class LabelUserLook extends WizContainer {
    componentName = 'labelUserLook'

    constructor(props) {
        super(props)
        const { history } = props
        let detailInfo = {};
        if (history.location && history.location.record) {
            detailInfo = history.location.record
            Session.set('detailInfo', detailInfo)
        } else {
            detailInfo = Session.get('detailInfo') || {}
        }
        this.detailInfo = detailInfo
    }

    _componentDidMount() {
    }

    _getUserIdentityInfo = (identityLists) => {
       let content = Array.isArray(identityLists) && identityLists.length ?
           identityLists.map((e) => <p>{`${e['orgName']}-${e['positionName']}`}</p>) : ''
        return content
    }

    _render() {
        const items = this.detailInfo

        return (
            <React.Fragment>
                <WizCard>
                        <Descriptions column={1} style={{ paddingLeft: 25 }} bordered={true}>
                            <Descriptions.Item label='标签名称'>{items.labelName}</Descriptions.Item>
                            <Descriptions.Item label='标签编码'>{items.labelCode}</Descriptions.Item>
                            <Descriptions.Item label='标签状态'>{_getValue('state', items.labelState)}</Descriptions.Item>
                            <Descriptions.Item label='学员账号'>{items.userName}</Descriptions.Item>
                            <Descriptions.Item label='学员姓名'>{items.fullName}</Descriptions.Item>
                            <Descriptions.Item label='任职信息'>{this._getUserIdentityInfo(items.identityLists)}</Descriptions.Item>
                            <Descriptions.Item label='贴标时间'>{formatterDate(items.operationTime)}</Descriptions.Item>
                            <Descriptions.Item label='是否推送课程'>{_getValue('baseType', items.pushType)}</Descriptions.Item>
                            <Descriptions.Item label='是否完成课程'>{_getValue('baseType', items.completeType)}</Descriptions.Item>
                            <Descriptions.Item label='完成时间'>{items.completeTime}</Descriptions.Item>
                            <Descriptions.Item label='是否撕除标签'>{_getValue('baseType', items.tearType)}</Descriptions.Item>
                            <Descriptions.Item label='用户贴标状态'>{_getValue('state', items.state)}</Descriptions.Item>
                        </Descriptions>
                </WizCard>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { } = state;
    return {
    }
};

export default connect(mapStateToProps)(LabelUserLook)

